import { useSettings } from 'Settings'
import Graph from '../Graph'
import { STSGraph } from './STS'
import ValueTransform from 'ValueTransform'
import { getBorderBreaks, setSectionTo } from 'Vectorgraph'


const VSUP = (props) => {
	const [settings] = useSettings()
	let graph = STSGraph()

	const acc = settings['supervisory level']['v_lvl_acc'].value
	const v_ulp_ldo = parseFloat(settings['ldo levels']['v_ulp_ldo'].value)
	const force_vsup = settings['vsup']['force enable'].value
	const initial_state = parseInt(settings['vsup']['initial state'].value)
	const v_apl_max_hi = ValueTransform(settings['supervisory level']['v_apl_max_hi'].value, acc)
	const v_bat_min_hi_dis = ValueTransform(settings['supervisory level']['v_bat_min_hi_dis'].value, acc)

	if (initial_state === 1) // 1 = Sleeping
		graph = setSectionTo(graph, 0, 1.65, 0)

	getBorderBreaks(graph, v_bat_min_hi_dis, false).forEach(p => {
		if (p[0] < 4 && p[0] > 3)
			p[0] = 4
		graph = setSectionTo(graph, p[0], p[1], 0)
	})

	if (force_vsup) {
		getBorderBreaks(graph, v_ulp_ldo, true).forEach(p => {
			graph = setSectionTo(graph, p[0], p[1], v_ulp_ldo)
		})
	} else {
		getBorderBreaks(graph, v_apl_max_hi, true).forEach(p => {
			graph = setSectionTo(graph, p[0], p[1], v_ulp_ldo)
		})
	}

	graph = setSectionTo(graph, 6, 7, 0)

	return (
		<Graph {...props} points={graph} />
	)
}

export default VSUP
